import styled from 'styled-components';
import React from 'react';
import { Badge, CarouselSlider, ModuleContainer } from '../../components';
import { Breakpoints } from '../../utils';
import { withAnalytics } from '../../analytics';
import PropTypes from 'prop-types';

const Item = styled.a`
  background: url(${({ mobileImage, image }) => mobileImage || image}) no-repeat
    center center;
  background-size: cover;
  display: block !important;
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%; /* square */

  @media only screen and (min-width: ${Breakpoints.wideMobileBreakpoint}px) {
    background-image: url(${({ mobileImage, image }) => image || mobileImage});
    padding-bottom: ${(20 / 43) * 100}%; /* ratio from the designer */
  }
`;

// Render Just Launched Carousel
const JustLaunched = ({ data: justLaunched, analytics }) => {
  const justLaunchedOptions = {
    infinite: true,
    slidesToShow: 1,
    arrows: false,
    autoplay: false,
    swipe: false,
    responsive: [
      {
        breakpoint: Breakpoints.computerBreakpoint,
        settings: { arrows: true }
      }
    ]
  };

  const onCarouselClick = link => {
    analytics.trackEvent('Just Launched Panel', {
      url: link
    });
  };

  return (
    <ModuleContainer fill>
      <CarouselSlider options={justLaunchedOptions}>
        {justLaunched.map(item => {
          const isExternal = item.ctaLink && item.ctaLink.startsWith('http');
          return (
            <Item
              draggable="false"
              href={item.ctaLink}
              target={isExternal ? '_blank' : '_self'}
              className="carouselslider-text"
              key={item.id}
              image={item.backgroundImage}
              mobileImage={item.mobileBackground}
              onClick={e => {
                onCarouselClick(item.ctaLink);
              }}
            >
              {item.justLaunched && <Badge>JUST LAUNCHED</Badge>}
            </Item>
          );
        })}
      </CarouselSlider>
    </ModuleContainer>
  );
};

JustLaunched.propTypes = {
  data: PropTypes.array,
  analytics: PropTypes.object
};

export default withAnalytics(JustLaunched);



// WEBPACK FOOTER //
// ./src/pages/Landing/JustLaunched.js